<template lang="html">
  <v-container>
    <v-row>
      <v-col cols="11">
        <v-icon> event_note </v-icon>
        <span class="headline mx-2">Promises</span>
      </v-col>
      <v-col 
        cols="1"
      >
        <employee-promises-dialog-create 
          v-if="isMyProfile"
          :employee-uid="employeeUid"
          @added="emitCreated"
        />
      </v-col>
    </v-row>

    <v-expansion-panels      
      focusable
      multiple
    >
      <v-expansion-panel
        v-for="(item,i) in computedPanels"
        :key="i"
      >
        <v-expansion-panel-header :disabled="i === 0 ? publicPromises.length <1:privatePromises<1">
          <span class="subtitle-1 mx-2">
            {{ item }} ({{ i === 0 ? publicPromises.length:privatePromises.length }})
          </span>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <employee-promises-profile-card
            v-if="i===0"
            :promises="publicPromises"
            @cancelled="loadData()"
          />

          <employee-promises-profile-card
            v-if="i===1"
            :promises="privatePromises"
            @cancelled="loadData()"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <br><br>
  </v-container>
</template>

<script>
  export default {
    components: {
      EmployeePromisesDialogCreate: () => import('@/components/employee/promises/DialogCreate'),
      EmployeePromisesProfileCard: () => import('@/components/employee/promises/ProfileCard'),
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },         
    },
    data () {
      return {
        profilePanels: [
          'Public Promises',
          'Private Promises',
        ],
        limitedPanels: [
          'Public Promises',
        ],
        promises: [],
      }
    },
    computed: {
      computedPanels () {
        if (this.isMyProfile || this.$hasPermissionTo(['view private promises'])) return this.profilePanels
        return this.limitedPanels
      },
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
      publicPromises () {
        return this.promises.filter(promise => promise.is_private === 0)
      },
      privatePromises () {
        return this.promises.filter(promise => promise.is_private === 1)
      },
    },  
    created () {
      this.loadData()
    },
    methods: {
      emitCreated () {
        this.loadData()
      },
      loadData () {
        this.$api.promises().list(this.employeeUid)
          .then((res) => {
            this.promises = res.data
          })
      },
    },
  }
</script>

<style lang='css' scoped>

  ::v-deep .v-expansion-panel-content__wrap{
    padding-right: 0px;
    padding-left: 0px;
  }

  ::v-deep .v-list-item__action,.v-list-item__avatar{
    align-items: unset;
  }

</style>
